import React, { useState } from "react";

import { Button, SectionCard, Stack } from "shared/ui";
import { MenuChatDto } from "services/menu/restModels";

import { useMenuSettingsContext } from "features/MenuSettings/context";

import { ChatDialog, ChatDialogTarget } from "./components/ChatDialog";
import {
    AddButtons,
    ChatMeta,
    ChatRow,
    ChatTitle,
    EmptyText,
    RowActions,
} from "./styles";

const filtersSummary = (chat: MenuChatDto): string => {
    const parts: string[] = [];
    if (chat.filters.some((item) => item.type === "WhitelistedOrderStatuses")) {
        parts.push("заказы");
    }
    if (chat.filters.some((item) => item.type === "CallWaiterForTable")) {
        parts.push("вызов персонала");
    }
    return parts.length > 0 ? parts.join(", ") : "уведомления выключены";
};

export const ChatsTab = () => {
    const { chats, iikoTerminals } = useMenuSettingsContext();
    const [dialogTarget, setDialogTarget] = useState<ChatDialogTarget | null>(null);

    return (
        <>
            <SectionCard
                title="Приём заказов и вызовов персонала"
                description="Чтобы точно не пропустить заказы, настройте уведомления в Telegram или MAX."
            >
                <Stack>
                    {chats.chats.length === 0 && (
                        <EmptyText>Пока нет ни одного чата</EmptyText>
                    )}

                    {chats.chats.map((chat, index) => (
                        <ChatRow key={`${chat.messenger}-${chat.chatId}`}>
                            <span>
                                <ChatTitle>{chat.chatTitle}</ChatTitle>
                                <ChatMeta>
                                    {chat.messenger === "Telegram" ? "Telegram" : "MAX"} ·{" "}
                                    {chat.chatId} · {filtersSummary(chat)}
                                </ChatMeta>
                            </span>
                            <RowActions>
                                <Button
                                    variant="text"
                                    onClick={() =>
                                        setDialogTarget({
                                            messenger: chat.messenger,
                                            editIndex: index,
                                        })
                                    }
                                >
                                    Изменить
                                </Button>
                                <Button
                                    variant="text"
                                    color="danger"
                                    onClick={() => chats.removeChat(index)}
                                >
                                    Удалить
                                </Button>
                            </RowActions>
                        </ChatRow>
                    ))}

                    <AddButtons>
                        <Button
                            variant="outlined"
                            onClick={() => setDialogTarget({ messenger: "Telegram" })}
                        >
                            Добавить Telegram
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => setDialogTarget({ messenger: "Max" })}
                        >
                            Добавить MAX
                        </Button>
                    </AddButtons>
                </Stack>
            </SectionCard>

            {iikoTerminals.length > 0 && (
                <SectionCard
                    title="Терминалы iiko"
                    description="Привязаны интеграцией — меняются на странице интеграции."
                >
                    <Stack>
                        {iikoTerminals.map((terminal) => (
                            <ChatRow key={terminal.terminalGroupId}>
                                <ChatTitle>Терминал #{terminal.terminalGroupId}</ChatTitle>
                            </ChatRow>
                        ))}
                    </Stack>
                </SectionCard>
            )}

            <ChatDialog target={dialogTarget} onClose={() => setDialogTarget(null)} />
        </>
    );
};
